module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"itemType":"Service type","id":"Billing ID","date":"Date","tariff":"Tariff"}}')
  delete Component.options._Ctor
}
